<template>
  <div
    v-editable="blok"
    class="EmployeeTab"
    :class="desktopWidth('full')"
  >
    <EmployeeCardGroup
      v-for="group in blok.groups"
      :key="group._uid"
      :blok="group"
    />
  </div>
</template>

<script setup lang="ts">
import { EmployeeTabProps } from '#constants/types/storyblok';
import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';

const props = defineProps<{
  blok: EmployeeTabProps,
}>();

const { desktopWidth } = useVisualAppearancePlugin(props);
</script>